import * as XLSX from "xlsx";

function defFileName(){
    let date = new Date();
        let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return date.getFullYear() + "-" + month + "-" + day
}

//是否Utf8文件
function isUTF8(bytes) {
    var i = 0;
    while (i < bytes.length) {
        if ((// ASCII
            bytes[i] == 0x09 ||
            bytes[i] == 0x0A ||
            bytes[i] == 0x0D ||
            (0x20 <= bytes[i] && bytes[i] <= 0x7E)
        )
        ) {
            i += 1;
            continue;
        }

        if ((// non-overlong 2-byte
            (0xC2 <= bytes[i] && bytes[i] <= 0xDF) &&
            (0x80 <= bytes[i + 1] && bytes[i + 1] <= 0xBF)
        )
        ) {
            i += 2;
            continue;
        }

        if ((// excluding overlongs
            bytes[i] == 0xE0 &&
            (0xA0 <= bytes[i + 1] && bytes[i + 1] <= 0xBF) &&
            (0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF)
        ) ||
            (// straight 3-byte
                ((0xE1 <= bytes[i] && bytes[i] <= 0xEC) ||
                    bytes[i] == 0xEE ||
                    bytes[i] == 0xEF) &&
                (0x80 <= bytes[i + 1] && bytes[i + 1] <= 0xBF) &&
                (0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF)
            ) ||
            (// excluding surrogates
                bytes[i] == 0xED &&
                (0x80 <= bytes[i + 1] && bytes[i + 1] <= 0x9F) &&
                (0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF)
            )
        ) {
            i += 3;
            continue;
        }

        if ((// planes 1-3
            bytes[i] == 0xF0 &&
            (0x90 <= bytes[i + 1] && bytes[i + 1] <= 0xBF) &&
            (0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF) &&
            (0x80 <= bytes[i + 3] && bytes[i + 3] <= 0xBF)
        ) ||
            (// planes 4-15
                (0xF1 <= bytes[i] && bytes[i] <= 0xF3) &&
                (0x80 <= bytes[i + 1] && bytes[i + 1] <= 0xBF) &&
                (0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF) &&
                (0x80 <= bytes[i + 3] && bytes[i + 3] <= 0xBF)
            ) ||
            (// plane 16
                bytes[i] == 0xF4 &&
                (0x80 <= bytes[i + 1] && bytes[i + 1] <= 0x8F) &&
                (0x80 <= bytes[i + 2] && bytes[i + 2] <= 0xBF) &&
                (0x80 <= bytes[i + 3] && bytes[i + 3] <= 0xBF)
            )
        ) {
            i += 4;
            continue;
        }
        return false;
    }
    return true;
}


//文件流转BinaryString
function fixdata(data) {
    var o = "",
        l = 0,
        w = 10240;
    for(; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
    o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
    return o;
}
/**
 * 从 excel 文件读取数据1
 * @param excelRcFileBuffer excel 文件
 */
function importWorkbookByType(file,isBuffer) {
    if(!file){
        return reject("请选择文件");
    }
    //使用promise导入
    return new Promise((resolve, reject) => {
        // 通过FileReader对象读取文件
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
            //异步操作  excel文件加载完成以后触发
            try {
                let result = ((event || {}).target || {}).result;
                if(!result){
                    return reject("文件读取失败");
                }
                if(isBuffer) {
                    return resolve(XLSX.read(result, { type: 'buffer' }));
                    //return resolve(XLSX.read(new Uint8Array(result), { type: 'array' }));
                    //return resolve(XLSX.read(btoa(fixdata(result)), { type: 'base64' }));
                } else {
                    // 以二进制流方式读取得到整份excel表格对象
                    return resolve(XLSX.read(result, { type: 'binary' }));
                }
            } catch (e) {
                // 这里可以抛出文件类型错误不正确的相关提示
                reject("失败"); //导出失败
            }
        };
        if(isBuffer) {
            //ArrayBuffer对象以表示所读取文件的内容: readAsArrayBuffer(blob),因为数据很大，所以读取是异步的
            fileReader.readAsArrayBuffer(file);
        } else {
            // 以二进制方式打开文件
            fileReader.readAsBinaryString(file);
        }
    });
}
/**
 * 从 excel 文件读取数据2
 * @param excelRcFileBuffer excel 文件
 */
 function importWorkbook(file){
    if(!(file && file.arrayBuffer)){return Promise.reject('文件读取失败');}
    return file.arrayBuffer().then(result=>{
         //异步操作  excel文件加载完成以后触发
         try {
            var isCSV = file.name.split(".").reverse()[0] == "csv";//判断是否是 CSV
            if(isCSV){
                let data = new Uint8Array(result);
                let f = isUTF8(data);
                if (f) {
                    return XLSX.read(data, {type: 'array', codepage: 65001});
                } else {
                    return Promise.reject("请选择UTF8编码的CSV文件");
                    //需要安装 https://www.npmjs.com/package/codepage
                    // npm install -g codepage
                    //var str = cptable.utils.decode(936, data);
                    //return XLSX.read(str, { type: "string" });
                }
            }
            // 获取 workbook
            return XLSX.read(result, { type: 'buffer' });
            //return XLSX.read(new Uint8Array(result), { type: 'array' });
        } catch (e) {
            console.log("导入失败",e);
            // 这里可以抛出文件类型错误不正确的相关提示
            return Promise.reject("导入失败");
        }
    },e => {
        console.log("导入失败",e);
        // 这里可以抛出文件类型错误不正确的相关提示
        return Promise.reject("导入失败");
    });
}
/**
 * 获取workbook（默认第一个）工作表的名字
 */
function getSheetName(workbook,sheetIndex){
    if(!workbook){return "";}
    sheetIndex = sheetIndex || 0;
    // 找到第一张表
    const sheetNames = workbook.SheetNames || [];
    return sheetNames[sheetIndex];
}
/**
 * 获取workbook（默认第一个）工作表
 */
function getSheet(workbook,sheetIndex){
    if(!workbook){return null;}
    return getSheetByName(workbook,getSheetName(workbook,sheetIndex));
}
function getSheetByName(workbook,sheetName){
    if(!workbook){return null;}
    sheetName = sheetName || "Sheet1";
    return (workbook.Sheets || [])[sheetName];
}
/**
 * 工作表转换为json
 * @param opt 参数=>https://github.com/rockboom/SheetJS-docs-zh-CN/?tab=readme-ov-file#json
 * opt: {
 *     ////门店Id 月份 	 门店 	 门店固定费用 	 门店常规费用 	 门店运营费用 	 品牌服务费 	 装修均摊 	 月卡销售红线金额
 *     header: ["shopId", "month", "shop", "shopFixedCost", "shopNormalCost", "shopOperationCost", "brandServiceCost", "decorationShare", "monthCardSalesRedLineAmount"],
 *     blankrows: false, //否则跳过空行
 *     range: 1, //开始行
 *     }
 */
function sheetToJson(sheet, opt) {
    if(!sheet){
        return Promise.reject("文件对应工作表不存在");
    }
    // 读取内容
    return XLSX.utils.sheet_to_json(sheet, opt ||{});
}
/**
 * 获取导入Excel文件中一张工作表的数据
 * @param file excel 文件
 * @param opt 参数=>https://github.com/rockboom/SheetJS-docs-zh-CN/?tab=readme-ov-file#json
 * opt: {
 *     ////门店Id 月份 	 门店 	 门店固定费用 	 门店常规费用 	 门店运营费用 	 品牌服务费 	 装修均摊 	 月卡销售红线金额
 *     header: ["shopId", "month", "shop", "shopFixedCost", "shopNormalCost", "shopOperationCost", "brandServiceCost", "decorationShare", "monthCardSalesRedLineAmount"],
 *     blankrows: false, //否则跳过空行
 *     range: 1, //开始行
 *     }
 * @param workbookToSheetFun 从workbook获取一个Sheet对象返回，用于导入，默认null，默认返回第一张用于导入
 */
function importOneSheetJson(file,opt,workbookToSheetFun) {
    return importWorkbook(file).then(workbook => {
        if(!workbook){
            return Promise.reject("文件读取失败");
        }
        workbookToSheetFun = workbookToSheetFun || getSheet;
        // 读取内容
        return sheetToJson(workbookToSheetFun(workbook), opt ||{});
    });
};
function importOneSheetJsonBySheetIndex(file,opt,sheetIndex) {
    return importOneSheetJson(file,opt,workbook => getSheet(workbook,sheetIndex));
};
function importOneSheetJsonBySheetName(file,opt,sheetName) {
    return importOneSheetJson(file,opt,workbook => getSheetByName(workbook,sheetName));
};
// /**
//  * 获取导入Excel文件中多张工作表的数据
//  */
//  function importSheetsObjJsonByFile(file) {
//     return importWorkbook(file).then(workbook => {
//         if(!workbook){
//             return Promise.reject("文件读取失败");
//         }
//         let data = {}; // 存储获取到的数据
//         // 遍历每张工作表进行读取
//         for (const sheetName in workbook.Sheets) {
//             if (workbook.Sheets.hasOwnProperty(sheetName)) {
//                 // 将工作表转换为json数据
//                 data[sheetName] = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
//             }
//         }
//         return data;
//     });
// };
// function importSheetListJsonByFile(file) {
//     return importWorkbook(file).then(workbook => {
//         if(!workbook){
//             return Promise.reject("文件读取失败");
//         }
//         let data = []; // 存储获取到的数据
//         // 遍历每张工作表进行读取
//         for (const sheetName in workbook.Sheets) {
//             if (workbook.Sheets.hasOwnProperty(sheetName)) {
//                 // 将工作表转换为json数据
//                 data.push(XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]));
//             }
//         }
//         return data;
//     });
// };

function exportExcel(tableData, fileName, sheetName) {
    fileName = fileName || defFileName();
    let ws = XLSX.utils.aoa_to_sheet(tableData);
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName || '数据列表');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
}
function listToTableData(dataList, titleList, attrList) {
    dataList = dataList || [];
    //属性列表
    var allAttrList = Object.keys(dataList[0] || {});
    //标题行
    var curTitleList, curAttrList;
    //指定标题行导出
    if(titleList && Array.isArray(titleList)){
        curTitleList = titleList;
    }else{
        curTitleList = allAttrList;
    }
    if(attrList && Array.isArray(attrList)){
        curAttrList = attrList;
    }else{
        curAttrList = allAttrList;
    }
    //构造导出数据
    dataList = dataList.map(item => {
        return curAttrList.map(key=>item[key]||"");
    });
    return [curTitleList].concat(dataList);
}
function exportListData(dataList, fileName, sheetName, titleList, attrList) {
    dataList = dataList || [];
    //////用上面方法导出
    // //标题行
    // titleList = Object.keys(dataList[0] || {});
    // //构造导出数据
    // dataList = dataList.map(item => {
    //     return titleList.map(key=>item[key]||"");
    // });
    // var tableData = [titleList].concat(dataList);
    // //导出
    // exportExcel(tableData, fileName, sheetName);

    //指定标题行导出
    if(titleList){
        var tableData = listToTableData(dataList, titleList, attrList);
        exportExcel(tableData, fileName, sheetName);
        return;
    }

    fileName = fileName || defFileName();
    let ws = XLSX.utils.json_to_sheet(dataList);
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName || '数据列表');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
}

function createExcel(fileName) {
    if (this && this instanceof createExcel) {
        this.fileName = fileName || defFileName();
        this.wb = XLSX.utils.book_new();
        return this;
    }
    return new createExcel(fileName);
}
createExcel.prototype.getWB = function(){
    return this.wb;
};
createExcel.prototype.addSheet = function(tableData,sheetName){
    let ws = XLSX.utils.aoa_to_sheet(tableData);
    XLSX.utils.book_append_sheet(this.wb, ws, sheetName || '数据列表');
    return this;
};
createExcel.prototype.export = function(fileName){
    this.fileName = fileName || this.fileName || defFileName();
    XLSX.writeFile(this.wb, `${this.fileName}.xlsx`);
    return this;
};

const excelUtil = {
    defFileName,
    exportExcel,
    exportListData,
    listToTableData,
    XLSX,
    createExcel,

    //导入文件相关
    getSheetName,
    getSheet,
    getSheetByName,
    sheetToJson,
    importWorkbook,
    importOneSheetJson,
    importOneSheetJsonBySheetIndex,
    importOneSheetJsonBySheetName,
}
export default excelUtil;

